// Dropdown menu sizing and structure
.dropdownMenu {
  min-width: 450px;
  max-width: 450px;
  max-height: 500px;

  // Inside a Navbar react-bootstrap turns Popper off, so the menu is placed by CSS alone: right edge on the bell's.
  // Where the header collapses into its off-canvas menu (the apps' 1024px breaking point) the bell sits at the
  // panel's left, so that placement runs off the screen — the menu is pinned to the viewport instead. The extra
  // classes outrank Bootstrap's `.dropdown-menu-end[data-bs-popper]`.
  @media (max-width: 1024px) {
    &:global(.dropdown-menu)[data-bs-popper] {
      position: fixed;
      top: 4rem;
      right: 0.5rem;
      left: auto;
      margin-top: 0;
      width: calc(100vw - 1rem);
      min-width: 0;
      max-height: calc(100vh - 4.5rem);
      overflow-y: auto;
    }
  }
}

// Fixed header that doesn't scroll
.fixedHeader {
  flex-shrink: 0;
  background: var(--bs-dropdown-bg);
}

// Scrollable content area
.scrollableContent {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 400px;
}

// Individual notification item
.notificationItem {
  cursor: pointer;
  transition: background-color 0.15s ease-in-out;
  white-space: normal !important;

  &:hover {
    background-color: var(--bs-tertiary-bg);
  }

  &.noLink {
    cursor: default;
  }
}

// Content wrapper for text truncation
.contentWrapper {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

// Title text with ellipsis
.titleText {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
}

// Body preview with 2-line clamp
.bodyPreview {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
  word-break: break-word;
}

// Empty state container
.emptyState {
  min-height: 120px;
}

// Empty state icon
.emptyIcon {
  font-size: 2rem;
  opacity: 0.5;
}

// Tooltip body styling - global scope for portal rendering
:global(.notification-tooltip-body) {
  max-width: 300px;
}
